export default __webpack_public_path__ + "static/media/facebook_logo_white.68670643.svg";